



















import { mapGetters, mapMutations } from 'vuex'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'
import { shouldShowBanner } from '@/store/utils'

export default {
  name: 'Banner',
  data() {
    return {
      fallbackLink: 'https://services.sennder.com/michelin-tires',
      vasLinkByLocale: {
        en: 'https://services.sennder.com/michelin-tires',
        de: 'https://services.sennder.com/de/michelin-reifen',
        fr: 'https://services.sennder.com/fr/pneus-michelin',
        pl: 'https://services.sennder.com/pl/opony-michelin',
        it: 'https://services.sennder.com/michelin-tires',
        es: 'https://services.sennder.com/michelin-tires',
        pt: 'https://services.sennder.com/michelin-tires'
      },
      isOpen: false
    }
  },
  computed: {
    ...mapGetters(['isBannerOpen']),
    valueAddedServicesLink() {
      return this.vasLinkByLocale[this.$i18n.locale] || this.fallbackLink
    }
  },
  mounted() {
    this.isOpen = shouldShowBanner()
    this.setIsBannerOpen(this.isOpen)
  },
  methods: {
    ...mapMutations(['setIsBannerOpen']),
    handleClickEvent() {
      trackEvent(SEGMENT_EVENTS.VAS_BANNER_CLICK)
      this.setIsBannerOpen(false)
      this.isOpen = false
      localStorage.setItem('VAS_BANNER_CLICKED', 'true')
    }
  }
}
